import endOfMonth from 'date-fns/endOfMonth'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

import { SHORT_ISO_DATE_FORMAT } from '../../../utils'
import { Period } from './MonthMultiPicker.types'

export interface MonthPick {
  monthIndex: number
  year: number
}

export interface MonthPeriod {
  start: string
  end?: string
}

interface PickMonthParams {
  period: Period
  pick: MonthPick
}

interface IsMonthSelectedParams {
  period: Period
  pick: MonthPick
}

const firstDayOf = ({ monthIndex, year }: MonthPick) => new Date(year, monthIndex, 1)

const ordinalOf = ({ monthIndex, year }: MonthPick) => year * 12 + monthIndex

export const monthPickOf = (date: string | Date): MonthPick => {
  const parsed = typeof date === 'string' ? parseISO(date) : date

  return { monthIndex: parsed.getMonth(), year: parsed.getFullYear() }
}

export const pickMonth = ({ period, pick }: PickMonthParams): MonthPeriod => {
  if (!period.start || period.end) return { start: format(firstDayOf(pick), SHORT_ISO_DATE_FORMAT) }

  const anchor = monthPickOf(period.start)
  const [first, last] = ordinalOf(pick) < ordinalOf(anchor) ? [pick, anchor] : [anchor, pick]

  return {
    start: format(firstDayOf(first), SHORT_ISO_DATE_FORMAT),
    end: format(endOfMonth(firstDayOf(last)), SHORT_ISO_DATE_FORMAT),
  }
}

export const isMonthSelected = ({ period, pick }: IsMonthSelectedParams) => {
  if (!period.start) return false

  const month = ordinalOf(pick)
  const first = ordinalOf(monthPickOf(period.start))
  const last = period.end ? ordinalOf(monthPickOf(period.end)) : first

  return month >= first && month <= last
}
